import { render, staticRenderFns } from "./pglist.vue?vue&type=template&id=74c2ec26&scoped=true&"
import script from "./pglist.vue?vue&type=script&lang=js&"
export * from "./pglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2ec26",
  null
  
)

export default component.exports